import RelationshipMetadata from "../../RelationshipMetadata";

class ProjectPlanProjectPlanPhaseRelationshipMetadata extends RelationshipMetadata {
    constructor() {
        super();

        this.name = "ProjectPlanProjectPlanPhase";
        this.parentEnterpriseComponent = "ProjectPlan";
        this.childEnterpriseComponent = "ProjectPlanPhase";
        this.sourceAttribute = "USID";
        this.destinationAttribute = "ProjectPlanUSID";
    }
}

export default ProjectPlanProjectPlanPhaseRelationshipMetadata;